export default __webpack_public_path__ + "db82de1c39ac09b2819d9a4262e975b3.svg";